<template>
    <div  class="has-background-light pt-6" style="margin-top: 10px;">
        <div class="container pb-6">
        <h1 class="title py-3">Nos derniers numéros</h1>

        <b-message>
            Découvrez ci-dessous nos dernières parutions. Si l'une d'elles vous intéresse, veuillez consulter la page <router-link class="is-link" to="/page/achat-et-abonnement">Achat et Abonnement</router-link> pour plus d'informations
        </b-message>

        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notification is-light">
            <b>{{ error }}</b>
        </div>

        <div v-for="(post, index) in posts" v-bind:key="post._id" class="has-background-white blogpost post">
            <h2 v-cloak class="title is-4" v-bind:title="index">{{ post.title | capitalize }}</h2>
            <div class="has-text-left py-1">
                <span title="publié le" class="has-text-grey"><i class="fas fa-clock"></i>&nbsp;{{post.datepost | formatDate}}</span>
            </div>
            <template v-if="post.excerpt">
                <template v-if="post.illustration">
                    <div class="columns">
                        <div class="column is-6 py-5">
                            <div>
                                <figure class="image">
                                    <img @click="imageModal(post.illustration.path)" :src="post.illustration.path" alt="illustration">
                                </figure>
                            </div>
                        </div>
                        <div class="column is-6 py-6">
                            <p v-html="post.excerpt"></p>
                            <div class="has-text-centered">
                                <router-link class="button is-warning is-rounded my-3" :to="'/post/'+ post._id">Voir plus...</router-link>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p v-html="post.excerpt"></p>
                    <div class="has-text-centered py-5">
                        <router-link class="button is-warning is-rounded my-3" :to="'/post/'+ post._id">Voir plus...</router-link>
                    </div>
                </template>
            </template>
            <template v-else>
                <template v-if="post.illustration">
                    <div class="columns">
                        <div class="column is-6 py-5">
                            <div>
                                <figure class="image">
                                    <img :src="post.illustration.path" alt="illustration">
                                </figure>
                            </div>
                        </div>
                        <div class="column is-6 py-6">
                            <p v-html="post.editor"></p>
                            <div class="has-text-centered my-2"><br>
                                <social-sharing v-bind:url="curr_path+'/post/'+ post._id" hashtags="JournalParoissial" v-bind:title="post.title+' 👉 '" inline-template>
                                    <div>
                                        <network network="facebook">
                                            <i class="fab fa-facebook-square fa-2x"></i>
                                        </network><span style="visibility: hidden;">|||</span>
                                        <network network="twitter">
                                            <i class="fab fa-twitter-square fa-2x"></i>
                                        </network><span style="visibility: hidden;">|||</span>
                                        <network network="whatsapp">
                                            <i class="fab fa-whatsapp-square fa-2x"></i>
                                        </network><span style="visibility: hidden;">|||</span>
                                        <network network="linkedin">
                                            <i class="fab fa-linkedin fa-2x"></i>
                                        </network>
                                    </div>
                                </social-sharing>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p v-html="post.editor"></p>
                    <div class="has-text-centered my-2"><br>
                        <social-sharing v-bind:url="curr_path+'/post/'+ post._id" hashtags="JournalParoissial" v-bind:title="post.title+' 👉 '" inline-template>
                            <div>
                                <network network="facebook">
                                    <i class="fab fa-facebook-square fa-2x"></i>
                                </network><span style="visibility: hidden;">|||</span>
                                <network network="twitter">
                                    <i class="fab fa-twitter-square fa-2x"></i>
                                </network><span style="visibility: hidden;">|||</span>
                                <network network="whatsapp">
                                    <i class="fab fa-whatsapp-square fa-2x"></i>
                                </network><span style="visibility: hidden;">|||</span>
                                <network network="linkedin">
                                    <i class="fab fa-linkedin fa-2x"></i>
                                </network>
                            </div>
                        </social-sharing>
                    </div>
                </template>
            </template>
        </div>
        <nav v-if="posts && paginate" class="pagination" role="navigation" aria-label="pagination">
            <ul class="pagination-list">
                <li>
                    <a :disabled="indexpage<2" class="pagination-link" aria-label="prev" @click="indexpage--">
                        &lt;</a> </li>
                <li v-for="page in totalpages" v-bind:key="page">
                    <a v-bind:class="[page == indexpage ? 'is-current' : '', 'pagination-link']" :aria-label="'Page ' + page" aria-current="page" @click="indexpage = page">{{page}}</a>
                </li>
                <li>
                    <a :disabled="indexpage>totalpages-1" class="pagination-link" aria-label="next" @click="indexpage++">&gt;</a>
                </li>
            </ul>
        </nav>
    </div>
</div>
</template>
<script>
const axios = require('axios');
var SocialSharing = require('vue-social-sharing');

//import { ModalProgrammatic as Modal } from 'buefy'


export default {
    data: function() {
        return {
            maintitle: 'Parutions',
            paginate: false,
            loading: true,
            posts: null,
            error: null,
            indexpage: 1,
            limitperpage: 10,
            totalposts: null,
            totalpages: 1,
            curr_path: window.location.origin,
        }
    },
    components: {
        SocialSharing
    },
    name: 'Posts',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData',
        indexpage(numpage) { this.getPagePosts(numpage) }
    },
    methods: {
        fetchData() {
            this.error = this.posts = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_posts
            axios({
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { categorie: 'parution' },
                        sort: { datepost: -1 },
                    })
                })
                .then(function(response) {
                    vm.loading = false
                    vm.totalposts = response.data.total
                    vm.totalpages = Math.ceil(vm.totalposts / vm.limitperpage)
                    vm.posts = response.data.entries.slice(0, vm.limitperpage)
                })
                .catch(function() {
                    vm.error = 'erreur'
                })
        },
        getPagePosts: function(numpage) {
            var vm = this
            numpage = (numpage < 1) ? 1 : ((numpage > vm.totalpages) ? vm.totalpages : numpage)
            this.indexpage = numpage

            var fetchurl = this.$api_url_posts
            axios({
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { categorie: 'parution' },
                        limit: vm.limitperpage,
                        skip: (vm.limitperpage) * (numpage - 1),
                        sort: { datepost: -1 },
                    })
                }).then(function(response) {
                    vm.totalposts = response.data.total
                    vm.totalpages = Math.ceil(vm.totalposts / vm.limitperpage)
                    vm.posts = response.data.entries
                })
                .catch(function() {
                    vm.error = 'page introuvable'
                }).then(function() {
                    //window.scrollTo(0, 0)
                })

        },

        imageModal(imagepath) {
                const vnode = '<img src='+imagepath+'>'
                this.$buefy.modal.open({
                    content: vnode,
                })
            }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blogpost {
    border-left: 0px solid #000;
    ;
    margin-bottom: 0px;
    padding: 25px 25px;
    border-bottom: 1px solid #ddd;
}

a {
    color: #42b983;
}

div.post {
    /*width: 550px;*/
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    text-align: left;
}

.post .image {
    max-width: 220px;
    padding-left: auto;
    padding-right: auto;
    margin-left: auto;
    margin-right: auto;
}

.post .image:hover{
    cursor: pointer;
}
</style>